import service from '@/utils/https.js';

export function login(data = {}) {
  return service({
    url: '/user/login',
    method: 'post',
    data,
  });
}

export function logout(data = {}) {
  return service({
    url: '/user/logout',
    method: 'post',
    data,
  });
}
